/**
 * 將 line_msg_templates 的範本物件轉為 LineMessagePreview 的單則預覽 props
 *
 * 原本此邏輯散落在自動回應編輯器、Postback 編輯器等頁面各自維護一份，
 * 造成同一份轉換規則有多處副本；集中在此供所有需要預覽範本的頁面共用。
 */

/**
 * Imagemap 版面對應的可點擊區塊座標（比例值，0～1）
 * 範本只存 layout 代碼，預覽時需展開成實際區塊才能畫出分隔線
 */
export const IMAGEMAP_LAYOUTS = {
  full: [{ x: 0, y: 0, w: 1, h: 1 }],
  h2: [{ x: 0, y: 0, w: 1, h: .5 }, { x: 0, y: .5, w: 1, h: .5 }],
  v2: [{ x: 0, y: 0, w: .5, h: 1 }, { x: .5, y: 0, w: .5, h: 1 }],
  h3: [{ x: 0, y: 0, w: 1, h: 1 / 3 }, { x: 0, y: 1 / 3, w: 1, h: 1 / 3 }, { x: 0, y: 2 / 3, w: 1, h: 1 / 3 }],
  quad: [{ x: 0, y: 0, w: .5, h: .5 }, { x: .5, y: 0, w: .5, h: .5 }, { x: 0, y: .5, w: .5, h: .5 }, { x: .5, y: .5, w: .5, h: .5 }],
  t1b2: [{ x: 0, y: 0, w: 1, h: .5 }, { x: 0, y: .5, w: .5, h: .5 }, { x: .5, y: .5, w: .5, h: .5 }],
  t2b1: [{ x: 0, y: 0, w: .5, h: .5 }, { x: .5, y: 0, w: .5, h: .5 }, { x: 0, y: .5, w: 1, h: .5 }]
};

/** 訊息類型的中文標籤 */
export const MSG_TYPE_LABEL = {
  text: '文字',
  image: '圖片',
  video: '影片',
  flex: 'Flex',
  flex_carousel: 'Flex 輪播',
  image_carousel: '圖片輪播',
  imagemap: '圖文訊息'
};

/**
 * @param {Object|null} template - LineMsgTemplatePicker 選出的範本物件
 * @returns {Object} LineMessagePreview 的單則模式 props
 */
export function toLineMsgTemplatePreviewData(template) {
  if (!template) return { messageType: '' };

  const mc = template.messageContent || {};
  const tf = template.templateFields || {};
  const type = template.messageType;

  let textContent = '';
  let imageUrl = '';
  let previewImageUrl = '';
  let imagemapUrl = '';
  let textEmojis = [];
  let imagemapAreas = [];
  let carouselItems = [];
  let flexContent = null;

  if (type === 'text') {
    textContent = mc.text || '';
    textEmojis = Array.isArray(mc.emojis) ? mc.emojis : [];
  } else if (type === 'image') {
    imageUrl = mc.originalContentUrl || '';
  } else if (type === 'video') {
    previewImageUrl = mc.previewImageUrl || '';
  } else if (type === 'image_carousel') {
    carouselItems = (mc.template?.columns || []).map((c) => ({
      imageUrl: c.imageUrl || '',
      label: c.action?.label || ''
    }));
  } else if (type === 'imagemap') {
    imagemapUrl = mc.baseUrl || '';
    imagemapAreas = tf.layout ? (IMAGEMAP_LAYOUTS[tf.layout] || []) : [];
  } else if (type === 'flex' || type === 'flex_carousel') {
    // 範本可能存 flex wrapper，也可能直接存 bubble/carousel
    flexContent = (mc.type === 'flex' && mc.contents) ? mc.contents : mc;
  }

  return {
    messageType: type,
    textContent,
    textEmojis,
    imageUrl,
    previewImageUrl,
    imagemapUrl,
    imagemapAreas,
    carouselItems,
    flexContent
  };
}
